export const FALLBACK_IMAGE =
  'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-neutral-rectangle.png';
